import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

i18n
  .use(LanguageDetector) // Détecte la langue et la sauvegarde
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ar: { translation: ar }
    },
    fallbackLng: 'fr',
    detection: {
      // Ordre de détection : localStorage d'abord, puis cookie, puis navigateur
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'] // Où sauvegarder la langue
    },
    interpolation: { escapeValue: false }
  });

const updateDOM = (lng) => {
  document.documentElement.dir = i18n.dir(lng);
  document.documentElement.lang = lng;
};

// Exécuter au chargement initial
updateDOM(i18n.language);

// Écouter les changements futurs
i18n.on('languageChanged', (lng) => {
  updateDOM(lng);
});

export default i18n;